// extracted by mini-css-extract-plugin
export default {"fieldset":"login-selection_fieldset__uW8hz","buttons":"login-selection_buttons__22vlE","link":"login-selection_link__Yb-cX","button":"login-selection_button__kAq-0"};